import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  margin: 170px 0px 0px 0px;
  background-color: var(--white);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;

  // Canales Container
  .canalesContainer {
    width: 100%;
    max-width: 812px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
  }

  // Title
  .titleContainer {
    width: 100%;
  }

  .canalesContainer h2 {
    width: 100%;
    text-align: center;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.25em;
    letter-spacing: -0.015em;
    margin: 0px 0px 80px 0px;
  }

  .dataContainer {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
  }

  .dataContainer p {
    width: 100%;
    margin: 0px 0px 0px 0px;
    text-align: left;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    line-height: 28px;
  }

  .dataContainer a {
    cursor: pointer;
    text-decoration: none;
  }

  #wppButton {
    margin: 20px 0px 20px 0px;
    min-height: 28px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    text-decoration: none;
    color: var(--green);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 1em;
  }

  // WhatsApp Buttons Container
  #wppButton span {
    color: var(--green);
    margin: 0px 0px 0px 10px;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    text-decoration: none;
    transition: 0.1s all;
  }

  #wppButtonDiv {
    margin: 20px 0px 20px 0px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    color: var(--green);
    font-size: 1em;
  }

  .logoMobile {
    display: none;
  }

  #wppButtonDiv a {
    width: auto;
    color: var(--green);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    text-decoration: none;
  }

  #wppCanal3Frist {
    margin: 0px 0px 0px 10px;
  }

  #wppButtonDiv p {
    width: auto;
    color: var(--green);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    margin: 0px 8px 0px 8px;
  }

  #mailButton {
    width: 100%;
    color: var(--orange);
    display: flex;
    justify-content: flex-start;
  }

  a {
    transition: 0.1s all;
  }

  a:hover {
    color: var(--black) !important;
  }

  a:hover > span {
    color: var(--black) !important;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Title
    .canalesContainer h2 {
      font-size: 2em;
    }

    // Text
    .dataContainer p,
    #wppButton,
    #wppButton span,
    #wppButtonDiv,
    #wppButtonDiv a,
    #wppButtonDiv p {
      font-size: 0.96em;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Title
    .canalesContainer h2 {
      font-size: 1.9em;
    }

    // Text
    .dataContainer p,
    #wppButton,
    #wppButton span,
    #wppButtonDiv,
    #wppButtonDiv a,
    #wppButtonDiv p {
      font-size: 0.938em;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    margin: 100px 0px 0px 0px;

    // Canales Container
    .canalesContainer {
      max-width: 700px;
      justify-content: center;
    }

    // Title
    .canalesContainer h2 {
      font-size: 1.9em;
      margin: 0px 0px 60px 0px;
    }

    // Data Container
    .dataContainer {
      justify-content: center;
      margin: 50px 0px 0px 0px;
    }

    #mailButton {
      justify-content: center;
    }

    // Text
    .dataContainer p,
    #wppButton,
    #wppButton span,
    #wppButtonDiv,
    #wppButtonDiv a,
    #wppButtonDiv p {
      text-align: center;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Canales Container
    .canalesContainer {
      max-width: 600px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    // Canales Container
    .canalesContainer {
      max-width: 540px;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    // Canales Container
    .canalesContainer {
      max-width: 480px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Canales Container
    .canalesContainer {
      max-width: 400px;
    }

    // Title
    .canalesContainer h2 {
      text-align: left;
    }

    // Barras
    .barra {
      display: none;
    }

    // WhatsApp Button Div
    #wppButtonDiv {
      justify-content: center;
      flex-wrap: wrap;
    }

    // Logo Wpp Desktop
    #logoDesktop {
      display: none;
    }

    // Logo Wpp Mobile
    .logoMobile {
      display: block;
      margin-right: 10px;
    }

    #wppButtonDiv a {
      width: 100%;
      margin: 15px 0px 15px 0px;
      display: flex;
      justify-content: center;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    // Canales Container
    .canalesContainer {
      max-width: 88%;
    }
  }
`;

export default Container;
